export const lastEdit = {
  lastSaveBy: '',
  lastSaveAt: '',
  locationName: '',
};
